import { put } from "redux-saga/effects";

import { addBulkOptionsRequest } from "../actionCreaters";
import { checkboxInitals } from "../initials";
import { InitialOptionsActionType } from "../types";

export function* initialOptionsSaga({ payload: { fieldId } }: InitialOptionsActionType) {
    yield put(
        addBulkOptionsRequest({
            fieldId: fieldId,
            options: checkboxInitals,
        }),
    );
}
